import React from 'react';
import ReactModal from 'react-modal';
import { ThemeProvider, type DefaultTheme } from 'styled-components';
import { RouterProvider } from 'react-router-dom';
import { Provider } from 'react-redux';
import { ApiClient } from '@make-software/tg-mini-app-ui';

import { AuthDataProvider } from '@/features';
import { store } from '@/shared';
import router from '@/app/router';

import { casperTheme } from './theme';

ApiClient.configure({
  getExtraHeaders: () => ({
    'X-Auth-Provider': localStorage.getItem('auth_provider') ?? ''
  })
});

function App() {
  ReactModal.setAppElement('body');

  return (
    <ThemeProvider theme={casperTheme as unknown as DefaultTheme}>
      <AuthDataProvider>
        <Provider store={store}>
            <RouterProvider router={router} />
        </Provider>
      </AuthDataProvider>
    </ThemeProvider>
  );
}

export default App;
